import { GiftTheme } from 'models/gift.model';
import { Sku } from 'models/sku.model';
import { createContext, Dispatch, RefObject, SetStateAction, useContext } from 'react';
import { IAction, state } from 'reducers/ProductPageReducer';
import { IAction as CardCustomisationAction, State as CardCustomisationState } from 'reducers/CardCustomisationReducer';
import { WebConfig } from 'models/webConfig.model';

export interface ProductPageContextInterface {
  sku: Sku;
  currency: {
    cc: string;
    symbol: string;
    name: string;
  };
  state: state;
  dispatch: Dispatch<IAction>;
  configs: WebConfig;
  isMultiPurchase: boolean;
  isLayer: boolean;
  purchaseInstanceId: string;
  personalisedMessages: string[] | null;
  giftThemes: GiftTheme[];
  cardCustomisationState: CardCustomisationState;
  dispatchCardCustomisationAction: Dispatch<SetStateAction<CardCustomisationAction>>;
  userUploadedDesignFileInput: RefObject<HTMLInputElement>;
  setHasUpgradedZag: (value: boolean) => void;
}

export const ProductPageContext = createContext<ProductPageContextInterface>(null);

export const useProduct = () => {
  const context = useContext(ProductPageContext);

  if (!context) throw new Error('useProduct must be used within a ProductPageContext provider');

  return context;
};
